function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22.95 5.67a6.68 6.68 0 0 1-2.92-4.36c-.07-.39-.11-.8-.11-1.21h-4.78l-.01 19.15c-.08 2.14-1.85 3.87-4.01 3.87a4 4 0 0 1-1.86-.46 4.01 4.01 0 0 1-2.15-3.56c0-2.22 1.8-4.02 4.02-4.02.41 0 .81.07 1.19.19v-4.88a9 9 0 0 0-1.19-.09c-4.85 0-8.8 3.95-8.8 8.8 0 2.98 1.49 5.61 3.76 7.2 1.43 1 3.17 1.59 5.04 1.59 4.85 0 8.8-3.95 8.8-8.8v-9.7c1.87 1.35 4.17 2.14 6.65 2.14V6.75c-1.34 0-2.59-.4-3.63-1.08",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 .1h27.9V28H0z",
  style: {
    fill: "none"
  }
}));
export default SvgTiktok;